import OrganisationPickerModal from './OrganisationPickerModal'

export default function OrganisationPickerSelect({ onPick, title = 'Choose Organisation', disabled = false, ...props }) {
  const [open, setOpen] = useState(false)

  function handlePick(id, name) {
    onPick(id, name)
    setOpen(false)
  }

  return (
    <>
      <div className='fake-select-wrapper'>
        <div
          className='fake-select'
          onClick={disabled ? undefined : () => setOpen(true)}
          style={disabled ? { opacity: 0.6, cursor: 'not-allowed' } : undefined}
        >
          <span>{title}</span>
          <svg className='dropdown-icon' viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </div>
      </div>
      <OrganisationPickerModal open={open} hide={() => setOpen(false)} onPick={handlePick} {...props} />
    </>
  )
}
